import React from 'react'
import PropTypes from 'prop-types';
import {connect} from "react-redux";
import {FILTRO_IGUAL} from "../../framework2/ej2/UI/FormularioGridBusqueda";
import ClienteRestful from "../../framework2/ej2/network/ClienteRestful";
import {servicioRestfulCompleto, servidor} from "../Configuracion";
import ListaChecks from "../../framework2/ej2/UI/ListaChecks";
import {Button, Intent, Menu, MenuDivider, Spinner} from "@blueprintjs/core";
import MenuLateralItem from "../../framework2/blueprint/MenuLateralItem";
import {
    estadoChangePagina,
    PAGE_FACTURACION_ANALISIS, PAGE_FISCAL_ANALISIS,
    PAGE_LABORAL_CONTRATOS, PAGE_MODELOS,
    PAGE_PRESENTACIONESMODELOS, PAGE_ROLES,
    PAGE_SAGE_DATOS_MODELO_202,
    PAGE_SAGE_DIVIDIR_NOMINAS,
    PAGE_SAGE_DOCUMENTOS,
    PAGE_SAGE_FACTURACION_NOMINAS,
    PAGE_SAGE_MODIFICAR_EMPLEADO_TEXTO,
    PAGE_SAGE_REGISTRO_FACTURAS,
    PAGE_SAGE_REGISTRO_FACTURAS_CULTURA, PAGE_USUARIOS
} from "../redux/estado/actions";

const menus= [
    {titulo: 'General', menuid: 'general', nivel: 0},
    {titulo: 'Empresas', menuid: 'empresas', nivel: 1},

    {titulo: 'Laboral', menuid: 'sage', nivel: 0},
    {titulo: 'Dividir nóminas', menuid: 'divisionNomina', nivel: 1},
    {titulo: 'Modificar texto de sobre de empleado', menuid: 'modificacionTextoEmpleadoCategoría', nivel: 1},
    {titulo: 'Contratos', menuid: 'laboralContratos', nivel: 1},

    {titulo: 'Facturación', menuid: 'facturacion', nivel: 0},
    {titulo: 'Documentos Registro mercantil', menuid: 'modelosTributarios', nivel: 1},
    {titulo: 'Documentos Registro mercantil cultura', menuid: 'modelosTributarios', nivel: 1},
    {titulo: 'Facturación de nóminas', menuid: 'facturacionNominas', nivel: 1},
    {titulo: 'Análisis', menuid: 'facturacionAnalisis', nivel: 1},

    {titulo: 'Fiscal', menuid: 'fiscal', nivel: 0},
    {titulo: 'Modelos tributarios', menuid: 'modelosTributarios', nivel: 1},
    {titulo: 'Presentaciones de modelo', menuid: 'modelosTributarios', nivel: 1},
    {titulo: 'Información del modelo 202', menuid: 'modelosTributarios', nivel: 1},
    {titulo: 'Análisis', menuid: 'facturacionAnalisis', nivel: 1},

    {titulo: 'Administración', menuid: 'administracion', nivel: 0},
    {titulo: 'Modelos', menuid: 'modelos', nivel: 1},
    {titulo: 'Seguridad', menuid: 'seguridad', nivel: 1},
    {titulo: 'Usuarios', menuid: 'usuarios', nivel: 2},
    {titulo: 'Roles', menuid: 'roles', nivel: 2},

];

class RolMenus extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            rol: props.rol,
            datos: [],
            marcadosIniciales: [],
            marcados: [],
        }
    }

    componentDidMount() {
        this.loadDatos();
    }

    static getDerivedStateFromProps(nextProps, prevState){
        const newState = {};
        if(nextProps.rol !== prevState.rol){
            newState.rol= nextProps.rol;
        }

        if (Object.keys(newState).length > 0)
            return newState;
        else
            return null;
    }

    loadDatos= () => {
        const {offset, numElementos, soloSinLeer,} =  this.state;
        const {rol} = this.props;

        this.setState({cargandoDatos: true});
        let condiciones= [{tipo: FILTRO_IGUAL, nombreCampo: "rolCodigo.codigo", valor: rol.codigo}];
        let filtro= {posInicial: 0, numElementos: 0, condiciones: condiciones, orden: [{nombreCampo:"menuid", asc:false}]};
        let url= servidor + servicioRestfulCompleto + "list/Rolaccion";
        const clienteRestful = new ClienteRestful().setUrl(url);
        console.log("url: ", url);
        clienteRestful.doPost(filtro, response => {
            console.log(response);
            let marcados= [];
            response.forEach ( (dato) => {
                marcados.push(dato.menuid);
            });
            this.setState({datos: response, marcados: marcados, marcadosIniciales: marcados, cargandoDatos: false});
        });
    }


    marcadosChanged = (newMarcados) => {
        this.setState({marcados:newMarcados});
    }

    guardar= () => {
        const {marcados} = this.state;
        const {rol, onGuardado} = this.props;

        let parametros= {
            rolCodigo: rol.codigo,
            marcados: marcados
        }
        let url= servidor + "completo/restful/servicio/Rolaccion/actualizar";
        const clienteRestful = new ClienteRestful().setUrl(url);
        clienteRestful.doPost( parametros,response => {
            if (clienteRestful.isExito()) {
                //alert ("Guardado correctamente");
                onGuardado && onGuardado();
            }
        });

    }



    render() {
         const {marcadosIniciales, cargandoDatos} = this.state;
         //console.log("marcadosIniciales: ", marcadosIniciales);
         return (
            <>
                { (cargandoDatos) &&  <Spinner intent={Intent.PRIMARY} size={50} /> }
                <ListaChecks items={menus} campoTexto="titulo" campoId="menuid"
                             marcadosIniciales={marcadosIniciales}
                             onMarcadosChanged={this.marcadosChanged}
                             desplazamintoNivel={50}
                             anchoCheck={700}
                />
                <div className="botonera" tabIndex="-1">
                    <Button icon="saved" className="boton" onClick={this.guardar} text="Guardar" />
                </div>
            </>
        )
    }


}

RolMenus.propTypes = {
    rol: PropTypes.object,
    onGuardado: PropTypes.func,
}


const mapStateToProps = function(state) {
    return {
        configuracion: state.configuracion,
    }
}

export default connect(mapStateToProps)(RolMenus);
